import React from 'react'
import Moment from 'react-moment'
import { lower } from 'change-case'
import { Icon, Popup } from 'semantic-ui-react'

import { StatusTag } from 'components'
import { numberFormat } from './helper'

import { DivText } from './styled'

export const pouStatus = {0:'Draft',1:'New',2:'In Progress',3:'Revise',4:'Completed',5:'Reject',6:'Cancelled'}

export const columns = { 
  tPOUs:[
    {
      Header: '',
      accessor: 'isSpecialCreditTerm',
      width: 30,
      Cell:row=>(row.value&&<DivText><Icon name='star' color='yellow'/></DivText>)
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 100,
      Cell:row=>(<DivText><StatusTag status={row.value} statusName={pouStatus[row.value]}/></DivText>)
    },{
      Header: 'Doc No.',
      accessor : row =>(row.status === 0 ? '-' : row.documentNumber),
      id:'documentNumber',
      width: 100,
      Cell:row=>(<DivText>{row.value}</DivText>)
    },{
      Header: 'PO No.',
      accessor : 'purchaseOrderNumber',
      width: 100,
      Cell:row=>(<DivText>{row.value}</DivText>)
    },{
      Header: ()=>(<DivText left>Title</DivText>),
      accessor : row =>(row.title.trim()),
      id:'title',
      width: 250
    }, {
      Header: ()=>(<DivText left>Project name</DivText>),
      accessor: 'projectName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: 'Company',
      accessor : 'companyName',
      width: 100,
      Cell:row=>(<DivText left>{row.value}</DivText>)
    },{
      Header: ()=>(<DivText left>Requester</DivText>),
      accessor: 'requesterName',
      width: 100,
      Cell: row => (row.value&&<DivText left>{`${row.value||'-'}`}</DivText>)
    },
    {
      Header: 'Submitted date',
      accessor: 'submittedDate',
      width: 120,
      Cell: row => (row.value&&
        <DivText>
          {row.value?
            <Moment format="DD MMM YYYY HH:mm">{row.value}</Moment>
            :
            '-'
          }
        </DivText>)
    }, {
      Header: 'Modified date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value&&<DivText><Moment format="DD MMM YYYY HH:mm">{row.value}</Moment></DivText>)
    }
  ],

  tPOItem:[
    {
      Header: 'No',
      accessor: 'lineNo',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    },
    {
      Header: 'Material No.',
      accessor: 'materialNo',
      width: 120,
      Cell: row => (<DivText>{row.value}</DivText>)
    },
    {
      Header: 'Item Name',
      accessor: 'itemName',
      width: 100,
    },
    {
      Header: 'Description',
      accessor: 'remark',
      Cell: row => <Popup content={row.value} basic hoverable trigger={<span className='rt-td'>{row.value}</span>} />
    },
    {
      Header: 'Quantity',
      accessor: 'sapQtyRemain',
      width: 100,
      Cell: row => (<DivText right>{numberFormat(row.value,false,3)}</DivText>)
    },
    {
      Header: 'Unit',
      accessor: 'unitName',
      width: 100,
    },
    {
      Header: 'Unit Price',
      accessor : 'netPrice',
      width: 100,
      Cell: row => (<DivText right>{numberFormat(row.value)}</DivText>)
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    },
    {
      Header: 'Amount',
      accessor: 'sapAmount',
      width: 100,
      Cell: row => (<DivText right>{numberFormat(row.value)}</DivText>)
    },
  ]
}